import React from 'react';
import { Card, Row, Col, Typography, List, Tooltip } from "antd";
import { TrophyOutlined, DollarOutlined, ShoppingOutlined, UserOutlined } from '@ant-design/icons';
import { getFullStateName } from './utils';

const { Text } = Typography;

const TopStatesSummary = ({ stateSummary }) => {
  // Sort states by total sales and take top 5
  const topStates = Object.entries(stateSummary || {})
    .sort(([,a],[,b]) => b.total_sales - a.total_sales)
    .slice(0, 12);

  return (
    <Card 
      title={<><TrophyOutlined /> Top  States</>}
      size="small"
      style={{ height: '100%' }}
    >
      {topStates.length === 0 ? (
        <Text type="secondary">No state data available</Text>
      ) : (
        <List
          size="small"
          dataSource={topStates}
          renderItem={([state, data], index) => {
            // Get full state name
            const fullStateName = getFullStateName(state);
            
            return (
              <List.Item>
                <Row style={{ width: '100%' }} align="middle">
                  <Col span={2}>
                    <Text strong>{index + 1}.</Text>
                  </Col>
                  <Col span={8}>
                    <div>
                      <Text strong style={{ display: 'block' }}>{fullStateName}</Text>
                      <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                        <UserOutlined style={{ marginRight: 4, color: '#722ed1', fontSize: '12px' }} />
                        <Text type="secondary" style={{ fontSize: '12px' }}>{data.customer_count.toLocaleString()}</Text>
                      </div>
                    </div>
                  </Col>
                  <Col span={7}>
                    <Tooltip title="Total sales in this state">
                      <div>
                        <DollarOutlined style={{ marginRight: 4, color: '#52c41a' }} />
                        <Text>{data.total_sales.toLocaleString(undefined, {maximumFractionDigits: 0})}</Text>
                      </div>
                    </Tooltip>
                  </Col>
                  <Col span={7}>
                    <Tooltip title="Total orders in this state">
                      <div>
                        <ShoppingOutlined style={{ marginRight: 4, color: '#1890ff' }} />
                        <Text>{data.order_count.toLocaleString()}</Text>
                      </div>
                    </Tooltip>
                  </Col>
                </Row>
              </List.Item>
            );
          }}
        />
      )}
    </Card>
  );
};

export default TopStatesSummary;
